import { keyframes, style } from '@vanilla-extract/css';

import { tokens } from './tipJarTheme.css';

const settle = keyframes({
  '0%': { transform: 'scale(1)' },
  '50%': { transform: 'scale(1.06)' },
  '100%': { transform: 'scale(1)' },
});

export const meter = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
});

export const amountLine = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  columnGap: '8px',
  margin: 0,
  fontVariantNumeric: 'tabular-nums',
});

export const raised = style({
  fontFamily: tokens.headerFont,
  fontSize: '28px',
  fontWeight: 700,
  lineHeight: '34px',
  letterSpacing: '-0.02em',
  '@media': {
    'screen and (min-width: 640px)': { fontSize: '32px', lineHeight: '38px' },
  },
});

export const goal = style({
  fontSize: '15px',
  fontWeight: 500,
  color: tokens.muted,
});

export const track = style({
  position: 'relative',
  height: '8px',
  overflow: 'hidden',
  borderRadius: '999px',
  background: tokens.track,
});

export const fill = style({
  position: 'absolute',
  inset: 0,
  borderRadius: '999px',
  background: tokens.primary,
  transformOrigin: 'left center',
});

export const tick = style({
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: '2px',
  marginLeft: '-1px',
  background: tokens.surface,
});

export const status = style({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: '6px',
  margin: 0,
  fontSize: '14px',
  lineHeight: '20px',
  color: tokens.muted,
  fontVariantNumeric: 'tabular-nums',
});

export const funded = style({
  fontWeight: 600,
  color: tokens.ink,
});

export const milestones = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  margin: '2px 0 0',
  padding: 0,
  listStyle: 'none',
});

export const milestone = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  minHeight: '28px',
  boxSizing: 'border-box',
  padding: '0 12px',
  border: `1px solid ${tokens.line}`,
  borderRadius: '999px',
  background: tokens.surface,
  color: tokens.muted,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  transition: 'background-color 240ms ease, border-color 240ms ease, color 240ms ease',
});

export const milestoneReached = style({
  borderColor: tokens.primary,
  background: tokens.primary,
  color: tokens.onPrimary,
  animation: `${settle} 360ms ease-out`,
  '@media': {
    '(prefers-reduced-motion: reduce)': { animation: 'none', transition: 'none' },
  },
});

export const milestoneAmount = style({
  fontVariantNumeric: 'tabular-nums',
});
